module.exports = "/images/vendor/greenmotion-shared/Components/quotes/gm-icon-white.svg?063c413c61022c5f72fca57fb78bb233";


//////////////////
// WEBPACK FOOTER
// ./node_modules/greenmotion-shared/Components/quotes/images/gm-icon-white.svg
// module id = I65r
// module chunks = 22